import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../api/axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const bootstrapAuth = useCallback(async () => {
    const userRole = localStorage.getItem('erp_role');
    const username = localStorage.getItem('erp_username');
    if (!userRole || !username) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get('/auth/me');
      if (data?.data) {
        setUser(data.data);
      } else {
        // Unexpected empty response — clear stale session
        localStorage.removeItem('erp_role');
        localStorage.removeItem('erp_username');
        localStorage.removeItem('erp_user');
      }
    } catch {
      // /auth/me failed (401, network error, etc.) — clear stale session silently
      // Do NOT redirect here; let React Router handle it via ProtectedRoute
      localStorage.removeItem('erp_role');
      localStorage.removeItem('erp_username');
      localStorage.removeItem('erp_user');
    } finally {
      setLoading(false);
    }
  }, []);


  useEffect(() => { bootstrapAuth(); }, [bootstrapAuth]);

  const login = async (roleCode, username, password) => {
    const { data } = await api.post('/auth/login', { roleCode, username, password });
    localStorage.setItem('erp_role', data.data.user.role);
    localStorage.setItem('erp_username', data.data.user.username);
    localStorage.setItem('erp_user', JSON.stringify(data.data.user));
    setUser(data.data.user);
    return data.data.user;
  };

  const logout = () => {
    localStorage.removeItem('erp_role');
    localStorage.removeItem('erp_username');
    localStorage.removeItem('erp_user');
    setUser(null);
  };

  const hasRole = (...roles) => user && roles.includes(user.role);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
